var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"wave-bg",attrs:{"src":"https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/label/barra-login.svg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }